import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";
import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";

import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";

import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { OrderPauseState } from "shared/cubiq-services/model/orders/OrderPauseState";

export class BfxBlotterOrdersContextMenuViewTicketItem extends BfxBlotterOrdersContextMenuItem {
  constructor() {
    super(
      BfxBlotterAction.ACTION_ORDER_VIEW_TICKET,
      "View Ticket",
      BfxBlotterOrdersContextMenuViewTicketItem.checkAvailableFn(),
      BfxBlotterOrdersContextMenuViewTicketItem.checkEnabledFn(),
      ContextMenuItemStateCommandCriteria.MenuItem,
      ContextMenuItemStateCommandCriteria.Item,
    );
  }

  public reset(): void {
    let oldState = this.state;
    this.state = new ContextMenuItemState();
    this.state.title = oldState.title;
  }

  private static checkAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
    ) {
      itemState.available = menuState.canViewTicket;
    };
  }

  private static checkEnabledFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      _menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
      item: CubiqTS.OrderDataImpl,
    ) {
      // For the moment, we only enable when a single ALGO is selected

      if (itemState.count === -1) {
        // NOP = we had one we can't use  - so we are done.
      } else {
        switch (item?.orderType) {
          case CubiqTS.OrderType.LIMIT_TP:
          case CubiqTS.OrderType.LIMIT_SL:
          case CubiqTS.OrderType.LIMIT_CALL:
          case CubiqTS.OrderType.MARKET:
          case CubiqTS.OrderType.MARKET_IOC:
          case CubiqTS.OrderType.MARKET_FOK:
            itemState.count == -1;
            break;
          // Commented code below for Limits story
          //  if (item?.gammaRungId !== null) {
          //     itemState.count == -1;
          //   } else {
          //     itemState.count++; // remember that we had "some" that were enabled
          //   }
          // break;
          case CubiqTS.OrderType.ALGO:
            itemState.count++;
            break;
          case CubiqTS.OrderType.RESERVED1:
          case CubiqTS.OrderType.RESERVED3:
          case CubiqTS.OrderType.BENCHMARK:
          case CubiqTS.OrderType.BMALGO:
            itemState.count == -1;
            break;
        }
      }
      itemState.enabled = itemState.count == 1; // if any were enabled - then the menu item should be.
    };
  }
}
